import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form, Button, Input } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import style from "./style.module.css";
import { Link } from "react-router-dom";
import mail001 from "../../images/mail001.jpg";
import { useHistory, useLocation } from "react-router-dom";
import RenderHelmet from "../../components/RenderHelmet";

import { useDispatch } from "react-redux";

import { logar } from "../../actions/Login.action";

import { addPersistOrigin } from "../../actions/PersistOrigin.action";

import ReactGA from "react-ga4";
import { GA_TRACKING_ID } from "../../configs/config";

function FullLogin(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const formRef = useRef();

  const persistOrigin = useSelector((state) => state.persistOrigin.origin);

  const { isAuthenticate, loadLogin, isFailure } = useSelector(
    (state) => state.login
  );

  useEffect(() => {
    ReactGA.initialize(GA_TRACKING_ID);
    ReactGA.send({ hitType: "pageview", page: "/login" });
    if (location.param?.origin) {
      dispatch(addPersistOrigin(location.param.origin));
    }
    if (location.state?.origin) {
      dispatch(addPersistOrigin(location.state.origin));
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (isAuthenticate) {
      if (persistOrigin) {
        history.push(persistOrigin);
      } else {
        history.push("/");
      }
    }
  }, [isAuthenticate, history, persistOrigin]);

  async function onFinish(values) {
    await dispatch(logar(values.usuario, values.senha));
  }

  function onFinishFailed(errorInfo) {
    // console.log("Failed:", errorInfo);
  }

  return (
    <div style={{ margin: "48px auto" }} className="container">
      <RenderHelmet title={"Cade Direito: Login"} />
      <Row>
        <Col sm={{ span: 24 }} md={{ span: 12 }}>
          <div style={{ textAlign: "center", padding: "8px 48px" }}>
            <h1 style={{ color: "var(--primary)" }}>Crie a sua conta</h1>
            <div className={style.textoLateral} style={{ margin: "24px auto" }}>
              <p
                style={{
                  fontSize: "1.2em",
                  color: "#809fbc",
                  marginBottom: 32,
                }}
              >
                É grátis e vai levar apenas alguns instantes.
              </p>
              <Link to={"/registrar"}>
                <Button type="primary" size="large">
                  Crie sua conta
                </Button>
              </Link>
            </div>
            <img alt="e-mail" style={{ width: "100%" }} src={mail001}></img>
          </div>
        </Col>
        <Col
          sm={{ span: 24 }}
          md={{ span: 12 }}
          style={{
            textAlign: "center",
          }}
          className={style.formContainer}
        >
          <h1 style={{ color: "var(--primary)" }}>Faça o login</h1>
          <Form
            name="basic"
            className={style.formLogin}
            ref={formRef}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={() => onFinishFailed()}
          >
            <Form.Item
              name="usuario"
              rules={[{ required: true, message: "Informe o usuário!" }]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Usuário"
              />
            </Form.Item>

            <Form.Item
              name="senha"
              rules={[{ required: true, message: "Informe a senha!" }]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Senha"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                style={{ width: "100%" }}
                htmlType="submit"
                className={style.buttonLogin}
                size="large"
                disabled={loadLogin}
              >
                Entrar
              </Button>
            </Form.Item>

            {isFailure ? (
              <div>
                <p className={style.loginFailure}>Login ou senha inválido(s)</p>
              </div>
            ) : (
              []
            )}

            {/*<Form.Item name="remember" valuePropName="checked" style={{marginBottom: 0}}>
          <Checkbox>Lembre-me</Checkbox>
          </Form.Item>*/}

            <div style={{ textAlign: "center" }}>
              <Link to={`/recuperar`}>Esqueci minha senha</Link>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default FullLogin;
